import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { KTIcon } from '../../../_myb/helpers';
import { trackEvent, AnalyticsEvent } from '../apps/analytics';

interface UpgradeDetail {
  message: string;
}

/**
 * Global upgrade-required modal.
 * Shown when a 403 Forbidden response is received from the API.
 * Mount once inside MasterLayout.
 */
export const UpgradeModal: React.FC = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent<UpgradeDetail>).detail;
      setMessage(detail?.message ?? '');
      setShow(true);
      trackEvent(AnalyticsEvent.UpgradeModalShown);
    };
    window.addEventListener('subscription:upgrade-required', handler);
    return () => window.removeEventListener('subscription:upgrade-required', handler);
  }, []);

  return (
    <Modal show={show} onHide={() => setShow(false)} centered size='sm'>
      <Modal.Body className='p-10 text-center'>
        <div
          className='w-60px h-60px rounded-circle bg-light-warning d-flex align-items-center justify-content-center mx-auto mb-6'
        >
          <KTIcon iconName='lock' className='text-warning fs-1' />
        </div>
        <h4 className='fw-bold mb-3'>{'Upgrade Required'.toTranslatedDisplay()}</h4>
        <p className='text-muted fs-6 mb-8'>
          {message || 'This feature is not available on your current plan. Upgrade to unlock it.'.toTranslatedDisplay()}
        </p>
        <div className='d-flex gap-3 justify-content-center'>
          <button className='btn btn-light' onClick={() => setShow(false)}>
            {'Dismiss'.toTranslatedDisplay()}
          </button>
          <button
            className='btn btn-primary'
            onClick={() => { setShow(false); navigate('/settings/subscription'); }}
          >
            {'View Plans'.toTranslatedDisplay()}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
